import { useCallback, useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { useSweetAlert } from '../sweetAlerts/useSweetAlert';
import { sendRequest } from '../requests/useRequest';
import { useForm } from '../forms/useForm';
import { ModalCreatePayMethod, ModalUpdatePayMethod, ModalDeletePayMethod } from '../../constant';
import { validarSesion } from '../tokens/useToken';
import { usePagination } from '../pagination/usePagination';


export const usePayMethods = () => {

    const history = useHistory();

    const [payMethods, setPayMethods] = useState([]);
    const [idPayMethod, setIdPayMethod] = useState(0);

    const [modal, setModal] = useState(false);
    const [modalTitle, setModalTitle] = useState("");
    const [method, setMethod] = useState("");

    const [createSweet] = useSweetAlert();
    const [loading, setLoading] = useState(false);

    // ? Delete dialog
    const [modalAlert, setModalAlert] = useState(false);
    const [showDeleteAlert, setShowDeleteAlert] = useState(false);
    const [loadingExcel, setLoadingExcel] = useState(false);


    const [searchPayMethod, setSearchPayMethod] = useState("");
    const [payMethodBackup, setPayMethodBackup] = useState([]);

    const [formValues, handleInputChange, reset, handleUpdateValues] = useForm({
        name: "",
        abbreviation: ""
    });

    const { name, abbreviation } = formValues;

    const [validaciones, setValidaciones] = useState({
        name_valid: false,
        abbreviation_valid: false
    });

    const numberItems = 10;
    const { totalPageCount, currentPage, nextPage, previousPage, goToPage } = usePagination(payMethods.length, numberItems);

    useEffect(() => {
        let startItems = 0;
        let endItems = numberItems;

        let aux = numberItems * currentPage;

        endItems = aux;

        startItems = endItems - numberItems;
        let listPay = [];
        payMethods.forEach((data, key) => {

            let posicion = key + 1;
            let visibleTable = false;

            if (posicion > startItems && posicion <= endItems) {
                visibleTable = true;
            }

            listPay.push({
                ...data,
                visibleTable: visibleTable


            });
        });

        setPayMethods(listPay);
    }, [totalPageCount, currentPage])



 const openDialog = (title, mode) => {
        setModalTitle(title);
        setMethod(mode);
        setModal(true);
    };

    const closeDialog = () => {
        setModal(false);
    };

   
     const openDeleteAlert = () => {
        setShowDeleteAlert(true); 
        setModalAlert(true);  
    };

    const closeDeleteAlert = () => {
        setShowDeleteAlert(false); 
        setModalAlert(false);   
    };

    const getPayMethods = useCallback(
        async () => {
            let requestOptions = {
                method: 'GET'
            };

            let listPayMethods = [];

            const respuesta = await sendRequest(requestOptions, "PayMethod/List");

            if (respuesta.code === 200) {

                if (respuesta.data.length >= 1) {

                    let startItems = 0;
                    let endItems = numberItems;
                    let aux = numberItems * currentPage;

                    endItems = aux;

                    startItems = endItems - numberItems;

                    respuesta.data.forEach((obj, index) => {

                        let posicion = index + 1;
                        let visibleTable = false;

                        if (posicion > startItems && posicion <= endItems) {
                            visibleTable = true;
                        }

//to
                        listPayMethods.push({
                            id_pay_method: obj.id_pay_method,
                            name: obj.name,
                            abbreviation: obj.abbreviation,
                            is_interfaced: obj.true,
                            visibility_particular: obj.visibility_particular ?? false,
                            visibleTable: visibleTable
                        });
                    });

                    setPayMethods(listPayMethods);
                    setPayMethodData(listPayMethods);
                    setPayMethodBackup(listPayMethods); 

                }
                else {
                    setPayMethods([]);
                }
            }
            else {
                validarSesion(history, respuesta.code, getPayMethods);
            }
        }, [history]
    )

    useEffect(() => {
        getPayMethods();
    }, [getPayMethods])

    const handleCreate = () => {
        handleUpdateValues({
            name: "",
            abbreviation: ""
        });

        setValidaciones({
            name_valid: false,
            abbreviation_valid: false
        });

        setIdPayMethod(0);
        setMethod("create");
        setModalTitle(ModalCreatePayMethod);
        openDialog("Crear metodo de pago ","create");
    }

    const saveCreate = async (e) => {
        e.preventDefault();

        if (validarForm()) {
            return;
        }

        setLoading(true);

        let data = JSON.stringify(formValues);

        let requestOptions = {
            method: 'POST',
            body: data
        };

        const respuesta = await sendRequest(requestOptions, "PayMethod/Create");

        if (respuesta.code === 200) {
            setLoading(false);
            createSweet("create", "success", "Exito!", "Se creo correctamente");

            closeDialog();
            getPayMethods();
            handleUpdateValues({
                name: "",
                abbreviation: ""
            });
        }
        else if (respuesta.code === 401) {
            validarSesion(history, respuesta.code, saveCreate);
            setLoading(false);
        }
        else if(respuesta.code === 500){
            createSweet("error", "error", "Método de pago", "Ocurrio un problema en el servidor");
            setLoading(false);
        }
        else{
            createSweet("error", "warning", "Método de pago", respuesta.data.msg);
            setLoading(false);
        }

    }

    const handleUpdate = (id_pay_method) => {
        let payMethod = payMethods.find(p => p.id_pay_method === parseInt(id_pay_method));

        handleUpdateValues({
            name: payMethod.name,
            abbreviation: payMethod.abbreviation
        });

        setValidaciones({
            name_valid: false,
            abbreviation_valid: false
        });

        setIdPayMethod(id_pay_method);
        setMethod("update");
        setModalTitle(ModalUpdatePayMethod);
        openDialog("Ediar tipo de pago", "update");
    }

    const saveUpdate = async (e) => {
        e.preventDefault();

        if (validarForm()) {
            return;
        }

        setLoading(true);

        let mValues = {
            id_pay_method: idPayMethod,
            ...{ ...formValues }
        };

        let data = JSON.stringify(mValues);
        let requestOptions = {
            method: 'PUT',
            body: data
        };

        const respuesta = await sendRequest(requestOptions, "PayMethod/Update");

        if (respuesta.code === 200) {
            getPayMethods();
            createSweet("update", "info", "Exito!", "Se actualizo el método de pago");
            setLoading(false);
            closeDialog();
        }
        else if (respuesta.code === 401) {
            validarSesion(history, respuesta.code, saveUpdate);
            setLoading(false);
        }
        else if(respuesta.code === 500){
            createSweet("error", "error", "Método de pago", "Ocurrio un problema en el servidor");
            setLoading(false);
        }
        else{
            setLoading(false);
            createSweet("error", "warning", "Método de pago", respuesta.data.msg);
        }
    }

    const handleDelete = (id_pay_method) => {
        let payMethod = payMethods.find(p => p.id_pay_method === parseInt(id_pay_method));

        handleUpdateValues({
            name: payMethod.name,
            abbreviation: payMethod.abbreviation
        });

        setIdPayMethod(id_pay_method);
        setMethod("delete");
        setModalTitle(ModalDeletePayMethod);
        openDeleteAlert();
    }

    const saveDelete = async (e) => {
        e.preventDefault();

        setLoading(true);

        let requestOptions = {
            method: 'DELETE'
        };

        const respuesta = await sendRequest(requestOptions, `PayMethod/${idPayMethod}`);
        if (respuesta.code === 200) {
            getPayMethods();
            setLoading(false);
            createSweet("delete", "success", "Exito!", "Se elimino correctamente");
            closeDeleteAlert();
        }
        else {
            validarSesion(history, respuesta.code, saveDelete);
        }
    }

    const validarForm = () => {
        let statusValidacion = false;
        let newValidaciones = {};

        if (formValues.name === "" || formValues.name.length < 3) {
            newValidaciones = {
                ...newValidaciones,
                name_valid: true
            };

            statusValidacion = true;
        }
        else {
            newValidaciones = {
                ...newValidaciones,
                name_valid: false
            };
        }

        if (formValues.abbreviation === "" || formValues.abbreviation.length < 2) {
            newValidaciones = {
                ...newValidaciones,
                abbreviation_valid: true
            };

            statusValidacion = true;
        }
        else {
            newValidaciones = {
                ...newValidaciones,
                abbreviation_valid: false
            };
        }

        setValidaciones(newValidaciones);

        return statusValidacion;
    }

    const [payMethodData, setPayMethodData] = useState([]) ;

    const handleSearchPay = (e) => {

        let busqueda = e.target.value;
        let newMethod = [];

        payMethodData.forEach(element => {            

            let cadena = element.name.toUpperCase();
            if (cadena.indexOf(busqueda.toUpperCase()) > -1) {
                element.visibleTable = true;
                newMethod.push(element);
            }
        });

        setPayMethods(newMethod);
    }


    const handleExcelPayMethod = async () => {
        setLoadingExcel(true);

        try {
            const XLSX = await import("xlsx");

            const data = payMethodData.map((item, index) => ({
                "#": index + 1,
                "Nombre": item.name || "----",
                "Abreviatura": item.abbreviation || "----",
                "Visible particular": item.visibility_particular ? "Sí" : "No"
            }));

            const worksheet = XLSX.utils.json_to_sheet(data);

            // tamaños de columnas
            worksheet["!cols"] = [
                { wch: 5 },
                { wch: 40 },
                { wch: 15 },
                { wch: 20 }
            ];

            const workbook = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(workbook, worksheet, "Métodos de pago");

            const excelBuffer = XLSX.write(workbook, {
                bookType: "xlsx",
                type: "array"
            });

            const blob = new Blob([excelBuffer], {
                type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
            });

            const url = window.URL.createObjectURL(blob);
            const link = document.createElement("a");
            link.href = url;
            link.download = "Metodos_de_pago.xlsx";
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            window.URL.revokeObjectURL(url);

        } catch (error) {
            console.error("Error al exportar Excel", error);
        }

        setLoadingExcel(false);
    };

    const handleSearchPayMethod = (value) => {

        const text = typeof value === "string"
            ? value
            : value?.target?.value || "";

        setSearchPayMethod(text);

        if (text === "") {
            setPayMethods(payMethodBackup);
            return;
        }

        const filtered = payMethodBackup.filter(item =>
            item.name?.toUpperCase().includes(text.toUpperCase()) ||
            item.abbreviation?.toUpperCase().includes(text.toUpperCase()) ||
            item.id_pay_method?.toString().includes(text)
        );

        setPayMethods(filtered);
    };

    const handleClearPayMethod = () => {
        setSearchPayMethod("");
        setPayMethods(payMethodBackup);
    };

    return {
        payMethods, method,
        name, abbreviation, handleInputChange, validaciones,
        closeDialog, modal, modalTitle, loading,
        handleCreate, saveCreate,
        handleUpdate, saveUpdate,
        handleDelete, saveDelete,
        nextPage, previousPage, goToPage, totalPageCount, currentPage,handleSearchPay,
        modalAlert, showDeleteAlert, closeDeleteAlert,
        handleExcelPayMethod, loadingExcel,

        handleSearchPayMethod,
        handleClearPayMethod,
        searchPayMethod

    }
}   
